import Modal from '../node_modules/modal-js/dist/modal';
import notification from 'notification-js';
import Validator from 'validator';
import Config from 'config';
import AuthDataStorage from "./AuthDataStorage";

export default class Login {
  constructor(options) {
    this.authDataStorage = new AuthDataStorage();
    this.loginButtons = options.loginButtons;
    this.showOnLogin = document.getElementsByClassName('showOnLogin');
    this.hideOnLogin = document.getElementsByClassName('hideOnLogin');
    this.editorLinks = document.getElementsByClassName('editorLink');

    let action;
    let queryStrings = window.location.search.substr(1).split("&");

    queryStrings.forEach((queryString) => {
      if (queryString.indexOf("action=") === 0) {
        action = queryString.substr(7);
      }
    });
    this.setupClickEvents();
    this.setupModal();
    this.checkLogin();


    if (action == "logout") {
      this.logoutUser();
      this.authDataStorage.logout();
    }
  }

  setupClickEvents() {
    for (var i=0; i< this.loginButtons.length; i++) {
      this.loginButtons[i].onclick = (event) => {
        if (event.target.innerHTML == "Login") {
          this.modal.show();
        } else {
          event.target.innerHTML = "Login";
          this.logoutUser();
          this.authDataStorage.logout();
        }
      };
    }
  }

  checkLogin() {
    this.modal.hide();
    var loggedIn = this.authDataStorage.getLoggedIn();
    var userData = JSON.parse(this.authDataStorage.getUserData());

    if(loggedIn) {
      var request = new XMLHttpRequest();

      request.onreadystatechange = function() {
        if (request.readyState == 4) {
          if (request.status !== 200) {
            return this.loginError('Their was an error logging in please try again.');
          }

          if (request.response !== "VALID_TOKEN") {
            this.logoutUser();
            this.authDataStorage.logout();
          }
        }
      }.bind(this);

      request.open("POST", Config.BACKEND_URL + '/checkUserToken');
      request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      request.setRequestHeader("Auth-Token", userData.token);
      request.send();

      userData = JSON.parse(this.authDataStorage.getUserData());
      for (var i=0; i< this.loginButtons.length; i++) {
        this.loginButtons[i].innerHTML = "Logout";
      }

      for (var i=0; i< this.showOnLogin.length; i++) {
        this.showOnLogin[i].style.display = "block";
      }

      for (var i=0; i< this.editorLinks.length; i++) {
        this.editorLinks[i].href = Config.EDITOR_URL + '?token=' + userData.token;
      }

      for (var i=0; i< this.hideOnLogin.length; i++) {
        this.hideOnLogin[i].style.display = "none";
      }
    }
  }

  logoutUser() {
    sessionStorage.clear();
    for (var i=0; i< this.showOnLogin.length; i++) {
      this.showOnLogin[i].style.display = "none";
    }

    for (var i=0; i< this.hideOnLogin.length; i++) {
      this.hideOnLogin[i].style.display = "block";
    }

    window.location.href = "/";
  }

  setupModal() {
    let modalTemplate = `
      <div>
        <a href="#" class="close-login">X</a>
        <h2>Login</h2>

        <form role="form">
            <div class="form-group">
                <label for="loginUsername">Username</label>
                <input type="text" class="form-control loginUsername" id="loginUsername" placeholder="Username">
            </div>
            <div class="form-group">
                <label for="loginPassword">Password</label>
                <input type="password" class="form-control loginPassword" id="loginPassword" placeholder="Password">
            </div>
            <input type="submit" name="submit" class='loginSubmitButton' value="Login" />
        </form>

      </div>
    `;

    var modalContainer = document.createElement('div');
    modalContainer.className = "loginPanel";
    document.body.appendChild(modalContainer);

    this.modal = new Modal({
      el: modalTemplate,
      containerEl: modalContainer,
      activeClass: 'modal-active',
      onShow: () => {
        var closeLogin = modalContainer.getElementsByClassName('close-login');
        closeLogin[0].style.display = 'block';
      },
      onHide: () => {
        var closeLogin = modalContainer.getElementsByClassName('close-login');
        closeLogin[0].style.display = 'none';
      },
      onClickOutside: (modal) => {
        modal.hide();
      }
    });

    this.modal.hide();
    this.modal.setup();

    var closeLogin = modalContainer.getElementsByClassName('close-login');
    closeLogin[0].style.display = 'none';
    closeLogin[0].onclick = (event) => {
      event.target.style.display = 'none';
      this.modal.hide();
    }
    this.formSubmit();
  }

  formSubmit() {
    let form = this.modal.el.getElementsByTagName('form')[0];
    form.onsubmit = (event) => {
      event.preventDefault();

      if (this.validateLoginForm(form)) {
        let username = form.getElementsByClassName('loginUsername')[0];
        let password = form.getElementsByClassName('loginPassword')[0];

        var request = new XMLHttpRequest();

        request.onreadystatechange = function() {
          if (request.readyState == 4) {
            if (request.status !== 200) {
              return this.loginError('Their was an error logging in please try again.');
            }

            var response = JSON.parse(request.responseText);
            if (!response.success) {
              return this.loginError('Invalid login details');
            }

            username.value = "";
            password.value = "";

            this.setUserAsLoggedIn(response);

            window.location.href = "/account.html";
          }
        }.bind(this);

        var data = {
          username: username.value,
          password: password.value
        }

        request.open("POST", Config.BACKEND_URL + '/login/account');
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.send(JSON.stringify(data));
      }

      return false;
    }
  }

  loginError(message) {
    notification.notify( 'error', message, {
      notification: {position: [ 'right', 'top' ]}
    });
  }

  validateLoginForm(form) {
    let username = form.getElementsByClassName('loginUsername')[0];
    let password = form.getElementsByClassName('loginPassword')[0];

    if (Validator.isNull(username.value) ||
        Validator.isNull(password.value)) {
      notification.notify( 'error', 'Please make sure all fields are entered', {
        notification: {position: [ 'right', 'top' ]}
      });
      return false;
    }

    return true;
  }

  setUserAsLoggedIn(response) {
    this.authDataStorage.setUserAsLoggedIn(response);
    this.checkLogin();
  }
}



// WEBPACK FOOTER //
// ./src/Login.js